"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OverviewButton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _useOverviewContext = require("../../hooks/useOverviewContext");
var _getApiInstance = require("../../utils/getApiInstance");
var _ImageWithSkeleton = require("../ImageWithSkeleton");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const OverviewButton = (param)=>{
    let { imageUrl, pageNumber } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { toggleOverviewOpen } = (0, _useOverviewContext.useOverviewContext)();
    const goToPage = (0, _react.useCallback)(()=>{
        toggleOverviewOpen();
        const ipaperApiInstance = (0, _getApiInstance.getApiInstance)();
        if (ipaperApiInstance) {
            ipaperApiInstance.paging.goToPage(pageNumber);
        }
    }, [
        pageNumber,
        toggleOverviewOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Item, {
        "data-testid": getTestId(_constants.OVERVIEW_BUTTON),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Button, {
            type: "button",
            onClick: goToPage,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ImageWithSkeleton.ImageWithSkeleton, {
                        src: imageUrl
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.PageNumber, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        component: "span",
                        fontWeight: "bold",
                        children: pageNumber
                    })
                })
            ]
        })
    });
};
exports.OverviewButton = OverviewButton;
